export default __webpack_public_path__ + "static/media/header-back-button.55cf9760.svg";